// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_App__G-Hx5 {
    background-color: white;
    border-radius: 25px;
    border: 1px solid #297FB0;
}

.styles_FlexContainer__ZkStc {
    display: flex;
    flex-direction: row;
}

.styles_Images__uT0Fu {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 20px;
}

.styles_Inputs__A-sVa {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 20px;
    padding: 20px;
}

.styles_InputFields__zMvAo {
    margin-right: 30px!important;
    margin-left: 30px!important;
}
.styles_CountryCityRow__t3Ucv{
    display: flex;
    justify-content: start;
}
.styles_CountryCityRow__t3Ucv > * {
    width: 100px;
}
.styles_WeightHeightRow__kP8Ps{
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
.styles_WeightHeightRow__kP8Ps > * {
    width: 300px;
}

.styles_SelectorWrapper__4pI7D {
    margin-right: 30px!important;
    margin-left: 30px!important;
    width: max-content;
}`, "",{"version":3,"sources":["webpack://./src/widgets/players-creation-form/styles.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;AACtB","sourcesContent":[".App {\n    background-color: white;\n    border-radius: 25px;\n    border: 1px solid #297FB0;\n}\n\n.FlexContainer {\n    display: flex;\n    flex-direction: row;\n}\n\n.Images {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    padding: 20px;\n}\n\n.Inputs {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    gap: 20px;\n    padding: 20px;\n}\n\n.InputFields {\n    margin-right: 30px!important;\n    margin-left: 30px!important;\n}\n.CountryCityRow{\n    display: flex;\n    justify-content: start;\n}\n.CountryCityRow > * {\n    width: 100px;\n}\n.WeightHeightRow{\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: space-between;\n}\n.WeightHeightRow > * {\n    width: 300px;\n}\n\n.SelectorWrapper {\n    margin-right: 30px!important;\n    margin-left: 30px!important;\n    width: max-content;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `styles_App__G-Hx5`,
	"FlexContainer": `styles_FlexContainer__ZkStc`,
	"Images": `styles_Images__uT0Fu`,
	"Inputs": `styles_Inputs__A-sVa`,
	"InputFields": `styles_InputFields__zMvAo`,
	"CountryCityRow": `styles_CountryCityRow__t3Ucv`,
	"WeightHeightRow": `styles_WeightHeightRow__kP8Ps`,
	"SelectorWrapper": `styles_SelectorWrapper__4pI7D`
};
export default ___CSS_LOADER_EXPORT___;
